import { NgModule } from '@angular/core';
import { LoadingOverlayComponent } from './loadingOverlay/loadingOverlay.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [LoadingOverlayComponent],
  exports: [
    LoadingOverlayComponent
  ]
})
export class LoadingOverlayModule { }
